// src/index.jsx
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { SocieteProvider } from "./context/SocieteContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <SocieteProvider>
      <App />
    </SocieteProvider>
  </React.StrictMode>
);
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  });
}

// === Enregistrement du service worker PWA ===
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("Service Worker enregistré :", reg.scope);
      })
      .catch((err) => {
        console.log("Échec enregistrement Service Worker :", err);
      });
  });
}
